import type { ParagraphLightFeatures2x2 as ParagraphLightFeatures2x2Data } from "@/lib/api/cms-catalog";
import type { ParagraphTranslations } from "../Paragraph.i18n";
import styles from "./ParagraphLightFeatures2x2.module.css";

/**
 * Layout 52 - `PARAGRAPH_LIGHT_FEATURES_2X2_LAYOUT`: light features 2x2.
 *
 * Grid 2x2 kart z ikonami (teal) + tytul + opis. Opcjonalny H2 nad gridem.
 * Karty: jasne tlo (surface-card), delikatny cien.
 *
 * Typowo: features/benefits produktu.
 */
export function ParagraphLightFeatures2x2({
  paragraph,
  t: _t,
}: {
  paragraph: ParagraphLightFeatures2x2Data;
  t: ParagraphTranslations;
}) {
  const { name: title, hero_text: heroText, text: lead, items } = paragraph;

  if (items.length === 0) return null;

  const hasHero = heroText && heroText.trim() !== "";
  const hasTitle = title && title.trim() !== "";
  const hasLead = lead && lead.trim() !== "";
  const hasHeader = hasHero || hasTitle || hasLead;

  return (
    <section className={styles.section}>
      {hasHeader ? (
        <div className={styles.header}>
          {hasHero ? <p className={styles.heroText}>{heroText}</p> : null}
          {hasTitle ? <h2 className={styles.title}>{title}</h2> : null}
          {hasLead ? <p className={styles.lead}>{lead}</p> : null}
        </div>
      ) : null}
      <ul className={styles.cards}>
        {items.map((item, idx) => {
          /* Type='badge' - pill z tekstem obok tytulu (nie ikony).
             Type='icon' (default backward compat) - ikona Nucleo w lewej kolumnie. */
          const showBadge = item.type === "badge" && item.badge;
          const showIcon = item.type !== "badge" && item.icon;
          return (
            <li key={idx} className={styles.card}>
              {showIcon ? (
                <i
                  className={`${styles.cardIcon} nc-icon-outline ${item.icon}`}
                  aria-hidden="true"
                />
              ) : null}
              <div className={styles.cardBody}>
                {showBadge || item.name ? (
                  <div className={styles.cardHeader}>
                    {showBadge ? (
                      <span className={styles.cardBadge}>{item.badge}</span>
                    ) : null}
                    {item.name ? (
                      <h3 className={styles.cardTitle}>{item.name}</h3>
                    ) : null}
                  </div>
                ) : null}
                {item.desc ? <p className={styles.cardDesc}>{item.desc}</p> : null}
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
